export default "__VITE_ASSET__31e1effc__"